import { render, staticRenderFns } from "./ArticleInfo.vue?vue&type=template&id=da480c7c&scoped=true"
import script from "./ArticleInfo.vue?vue&type=script&lang=ts"
export * from "./ArticleInfo.vue?vue&type=script&lang=ts"
import style0 from "./ArticleInfo.vue?vue&type=style&index=0&id=da480c7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da480c7c",
  null
  
)

export default component.exports